<div>
  <h6 class="text-secondary fw-bold">Solicitudes pendientes por aprobación</h6>

  <div class="overflow-auto">
    <table class="table table-bordered text-center">
      <thead>
        <tr>
          <th scope="col">ID solicitud</th>
          <th scope="col">Referente que solicitó el servicio</th>
          <th scope="col">Fecha de solicitud</th>
          <th scope="col">Nombre del Directivo</th>
          <th scope="col">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of dataTable">
          <td scope="row">{{ data.id }}</td>
          <td>{{ data.vcNombreReferente }}</td>
          <td>{{ data.dtFechaSolicitud }}</td>
          <td>{{ data.vcNombreDirectivo }}</td>
          <td class="d-flex justify-content-center">
            <div class="form-check">
              <input class="form-check-input"
                (change)="onSelected($event)"
                (change)="dataSelected(data)"
                type="checkbox"
                [value]="data.id"
                [checked]="valueSelected == data.id ? true:false">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
